
import "/data/jenkins/workspace/nodejs-paas-backend-prod/src/pages/overview/style.module.css?modules";
export default {"head_right": `head_right-DO3Lt-YG`,"headers": `headers-tqL6--gH`,"font_title": `font_title-RfdkUVFh`,"center": `center-LIm675vf`}
